// src/data/translations.js
export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      getStarted: 'Get Started'
    },
    bankCards: {
      title: {
        words: ['اختبر', 'البطاقة', 'المثالية', 'لكل', 'نمط', 'حياة']
      },
      subtitle: 'من المكافآت المميزة إلى الخيارات المناسبة للطلاب، اكتشف بطاقة مكين التي تناسب رحلتك المالية.',
      cards: [
        {
          name: 'مكين بريميوم',
          type: 'بطاقة مميزة',
          holder: 'أليكس جونسون',
          features: {
            title: 'المميزات الرئيسية',
            items: ['استرداد نقدي غير محدود', 'دخول صالات المطار', 'خدمة الكونسيرج']
          }
        },
        {
          name: 'مكين بزنس',
          type: 'بطاقة أعمال',
          holder: 'سارة سميث',
          features: {
            title: 'المميزات الرئيسية',
            items: ['تحليلات الأعمال', 'إدارة المصروفات', 'تحكم الفريق']
          }
        },
        {
          name: 'مكين الطلاب',
          type: 'بطاقة طلابية',
          holder: 'ماريا غارسيا',
          features: {
            title: 'المميزات الرئيسية',
            items: ['بدون رسوم سنوية', 'خصومات الطلاب', 'بناء التاريخ الائتماني']
          }
        }
      ],
      cta: {
        button: 'تقدم للحصول على بطاقتك',
        learnMore: 'اعرف المزيد'
      }
    },
    bankCards: {
      title: {
        words: ['Experience', 'the', 'perfect', 'card', 'for', 'every', 'lifestyle']
      },
      subtitle: 'From premium rewards to student-friendly options, discover the Makeen card that matches your financial journey.',
      cards: [
        {
          name: 'Makeen Premium',
          type: 'Premium Card',
          holder: 'ALEX JOHNSON',
          features: {
            title: 'Key Features',
            items: ['Unlimited Cashback', 'Airport Lounge Access', 'Concierge Service']
          }
        },
        {
          name: 'Makeen Business',
          type: 'Business Card',
          holder: 'SARAH SMITH',
          features: {
            title: 'Key Features',
            items: ['Business Analytics', 'Expense Management', 'Team Controls']
          }
        },
        {
          name: 'Makeen Basic',
          type: 'Student Card',
          holder: 'MARIA GARCIA',
          features: {
            title: 'Key Features',
            items: ['No Annual Fee', 'Student Discounts', 'Build Credit']
          }
        }
      ],
      cta: {
        button: 'Apply for Your Card',
        learnMore: 'Learn More'
      }
    },
    hero: {
      title: 'Banking Made Simple',
      subtitle: 'Experience the future of digital banking with Makeen',
      description: 'Seamless transactions, intelligent savings, and world-class security - all in one powerful app.',
      cta: 'Open Account',
      watchDemo: 'Watch Demo'
    },
    features: {
      title: 'Why Choose Makeen?',
      subtitle: 'Built for the modern digital lifestyle',
      items: [
        {
          title: 'Bank-Level Security',
          description: 'Advanced encryption and biometric authentication keep your money safe'
        },
        {
          title: 'Mobile First',
          description: 'Designed for smartphones with intuitive touch-friendly interface'
        },
        {
          title: 'Smart Cards',
          description: 'Contactless payments with real-time spending notifications'
        },
        {
          
          description: 'Grow your wealth with automated savings and investment options'
        }
      ]
    },
    bankCards: {
      title: {
        words: ['Experience', 'the', 'perfect', 'card', 'for', 'every', 'lifestyle']
      },
      subtitle: 'From premium rewards to student-friendly options, discover the Makeen card that matches your financial journey.',
      cards: [
        {
          name: 'Makeen Premium',
          type: '',
          holder: '',
          features: {
            title: 'Key Features',
            items: ['Unlimited Cashback', 'Airport Lounge Access', 'Concierge Service']
          }
        },
        {
          name: 'Makeen Business',
          type: 'Business Card',
          holder: '',
          features: {
            title: 'Key Features',
            items: ['Business Analytics', 'Expense Management', 'Team Controls']
          }
        },
        {
          name: 'Makeen Basic',
          type: 'Student Card',
          holder: '',
          features: {
            title: 'Key Features',
            items: ['No Annual Fee', 'Student Discounts', 'Build Credit']
          }
        }
      ],
      cta: {
        button: 'Apply for Your Card',
        learnMore: 'Learn More'
      }
    },
    stats: {
      users: 'Active Users',
      transactions: 'Monthly Transactions',
      countries: 'Countries Served',
      satisfaction: 'Customer Satisfaction'
    },
    testimonials: {
      title: 'Trusted by millions',
      subtitle: 'See what our customers say about their Makeen experience',
      items: [
        {
          name: 'Sarah Johnson',
          role: 'Business Owner',
          content: 'Makeen has transformed how I manage my business finances. The real-time insights are incredible.'
        },
        {
          name: 'Ahmed Al-Rashid',
          role: 'Freelancer',
          content: 'Finally, a bank that understands digital nomads. International transfers are seamless.'
        },
        {
          name: 'Maria Garcia',
          role: 'Student',
          content: 'The budgeting tools helped me save for my first car. Thank you Makeen!'
        }
      ]
    },
    cta: {
      title: 'Ready to join the future of banking?',
      subtitle: 'Open your Makeen account in minutes',
      button: 'Get Started Today'
    },
    footer: {
      description: 'Digital banking reimagined for the modern world',
      social: {
        title: 'Follow Us',
        connectWith: 'Connect with us:'
      },
      links: {
        company: 'Company',
        about: 'About Us',
        careers: 'Careers',
        press: 'Press',
        support: 'Support',
        help: 'Help Center',
        contact: 'Contact Us',
        faq: 'FAQ',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        security: 'Security'
      },
      contact: {
        phone: '+9647880111222',
        email: 'info@makeen.com',
        address: 'Mansour, Abu Jafaar Al Mansour'
      },
      tagline: 'Digital banking • Secure • Trusted by millions',
      copyright: '© 2024 Makeen Digital Bank. All rights reserved.'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      contact: 'التواصل',
      getStarted: 'ابدأ الآن'
    },
    hero: {
      title: 'الخدمات المصرفية أصبحت بسيطة',
      subtitle: 'اختبر مستقبل الخدمات المصرفية الرقمية مع مكين',
      description: 'معاملات سلسة، ادخار ذكي، وأمان عالمي المستوى - كل شيء في تطبيق واحد قوي.',
      cta: 'افتح حساب',
      watchDemo: 'شاهد العرض'
    },
    features: {
      title: 'لماذا تختار مكين؟',
      subtitle: 'مصمم لنمط الحياة الرقمية الحديثة',
      items: [
        {
          title: 'أمان على مستوى المصارف',
          description: 'تشفير متقدم ومصادقة بيومترية لحماية أموالك'
        },
        {
          title: 'تصميم للهاتف المحمول',
          description: 'مصمم للهواتف الذكية مع واجهة سهلة الاستخدام'
        },
        {
          title: 'بطاقات ذكية',
          description: 'مدفوعات بدون لمس مع إشعارات الإنفاق الفورية'
        },
        {
          title: 'أدوات الاستثمار',
          description: 'انمي ثروتك مع خيارات الادخار والاستثمار الآلية'
        }
      ]
    },
    bankCards: {
      title: {
        words: ['اختر', 'البطاقة', 'المثالية', 'لكل', 'نمط', 'حياة']
      },
      subtitle: 'من المكافآت المميزة إلى الخيارات المناسبة للطلاب، اكتشف بطاقة مكين التي تناسب رحلتك المالية.',
      cards: [
        {
          name: 'مكين بريميوم',
          type: 'بطاقة مميزة',
          holder: '',
          features: {
            title: 'المميزات الرئيسية',
            items: ['استرداد نقدي غير محدود', 'دخول صالات المطار', 'خدمة الكونسيرج']
          }
        },
        {
          name: 'مكين بزنس',
          type: 'بطاقة أعمال',
          holder: '',
          features: {
            title: 'المميزات الرئيسية',
            items: ['تحليلات الأعمال', 'إدارة المصروفات', 'تحكم الفريق']
          }
        },
        {
          name: 'مكين الطلاب',
          type: 'بطاقة طلابية',
          holder: '',
          features: {
            title: 'المميزات الرئيسية',
            items: ['بدون رسوم سنوية', 'خصومات الطلاب', 'بناء التاريخ الائتماني']
          }
        }
      ],
      cta: {
        button: 'تقدم للحصول على بطاقتك',
        learnMore: 'اعرف المزيد'
      }
    },
    stats: {
      users: 'المستخدمين النشطين',
      transactions: 'المعاملات الشهرية',
      countries: 'البلدان المخدومة',
      saatisfaction: 'رضا العملاء'
    },
    testimonials: {
      title: 'موثوق من قبل الملايين',
      subtitle: 'اطلع على ما يقوله عملاؤنا عن تجربتهم مع مكين',
      items: [
        {
          name: 'سارة جونسون',
          role: 'صاحبة عمل',
          content: 'مكين غيّر طريقة إدارتي لأموال عملي. الرؤى الفورية لا تصدق.'
        },
        {
          name: 'أحمد الراشد',
          role: 'مستقل',
          content: 'أخيراً، مصرف يفهم الرحالة الرقميين. التحويلات الدولية سلسة.'
        },
        {
          name: 'ماريا غارسيا',
          role: 'طالبة',
          content: 'أدوات وضع الميزانية ساعدتني في الادخار لسيارتي الأولى. شكراً مكين!'
        }
      ]
    },
    cta: {
      title: 'هل أنت مستعد للانضمام إلى مستقبل الخدمات المصرفية؟',
      subtitle: 'افتح حساب مكين في دقائق',
      button: 'ابدأ اليوم'
    },
    footer: {
      description: 'الخدمات المصرفية الرقمية معاد تصورها للعالم الحديث',
      social: {
        title: 'تابعنا',
        connectWith: 'تواصل معنا:'
      },
      links: {
        company: 'الشركة',
        about: 'من نحن',
        careers: 'الوظائف',
        press: 'الصحافة',
        support: 'الدعم',
        help: 'مركز المساعدة',
        contact: 'اتصل بنا',
        faq: 'الأسئلة الشائعة',
        privacy: 'سياسة الخصوصية',
        terms: 'شروط الخدمة',
        security: 'الأمان'
      },
      contact: {
        phone: '+9647880111222',
        email: 'info@makeen.com',
        address: 'المنصور, شارع ابو جعفر المنصور'
      },
      tagline: 'خدمات مصرفية رقمية • آمنة • موثوقة من الملايين',
      copyright: '© 2024 مصرف مكين الرقمي. جميع الحقوق محفوظة.'
    }
  }
};

export default translations;

// Named exports for specific languages
export const englishTranslations = translations.en;
export const arabicTranslations = translations.ar;

// Helper function to get translation by key path
export const getTranslation = (language, keyPath) => {
  const keys = keyPath.split('.');
  let result = translations[language];
  
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return keyPath; // Return the key path if translation not found
    }
  }
  
  return result;
};

// Helper function to check if language is RTL
export const isRTL = (language) => {
  return language === 'ar';
};

// Supported languages list
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' }
];